import "lazysizes";
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';

lazySizes.cfg.loadMode = 1;

import { Slider } from './slider';
const slider = new Slider();

lazySizes.cfg.loadMode = 1;

document.addEventListener('lazybeforeunveil', (e) => {

    // update sliders
    slider.update();

    let $element = $(e.srcElement);

    // lazyload video
    if ($element.hasClass('video')) {

        let $overlay = $element.siblings('.overlay');
        let $end = $element.siblings('.end');
        
        // play
        $element.on('play', function (e) {

            // hide overlay
            if ($overlay.length) {
                $overlay.hide();
            }
            if($end.length) {
                $end.hide();
            }

        });

        // end
        $element.on('ended', function(e) {
            if($end.length) {
                $element.removeAttr('controls');
                $element.css('opacity', '0');
                $end.fadeIn('fast');
            }
        });

    }




});